import type { Catalog } from '..'

export const panels: Catalog['panels'] = {
  layersTitle: 'Camadas',
  layersCollapsePanel: 'Recolher painel',
  layersExpandPanel: 'Expandir painel',
  layersCollapseAll: 'Recolher tudo',
  layersNewFrame: 'Novo frame',
  layersEmpty: 'Nenhum frame ainda. Pressione + para adicionar um ou peça um design ao agente.',
  layersNoMatch: 'Nada corresponde a “{query}”.',
  layersSearch: 'Buscar camadas',
  layersRailAria: 'Painel de camadas',
  layersRailCount: { one: 'Camadas · {count} frame', other: 'Camadas · {count} frames' },
  layersDesigning: 'criando…',
  layersEmptyFrame: 'frame vazio',
  layersShow: 'Mostrar',
  layersHide: 'Ocultar',
  layersLock: 'Bloquear',
  layersUnlock: 'Desbloquear',

  pagesTitle: 'Páginas',
  pagesAdd: 'Adicionar página',
  pagesName: 'Nome da página',
  pagesRename: 'Renomear',
  pagesDuplicate: 'Duplicar página',
  pagesDelete: 'Excluir página',
  pagesMoveSelection: 'Mover seleção para a página',
  pagesMoveSelectionPlaceholder: 'Mover seleção para a página…',
  pagesMoveFailed: 'Não foi possível mover todos os frames selecionados para a página',
  pagesSaveFailed: 'Não foi possível salvar as páginas',
  pagesDuplicateFailed: 'Não foi possível duplicar a página',

  memoryIntro: 'A Memória é como este canvas lembra do seu gosto — e como cada agente cria designs com ele.',
  memoryReferences: 'Referências',
  memoryRules: 'Regras',
  memoryDecisions: 'Decisões',
  memoryIntroReferences:
    '— fixe um frame que você adora (Fixar como referência, no inspetor dele). Os agentes copiam as cores, a tipografia e o layout dele quando criam algo novo.',
  memoryIntroRules: '— guias de estilo que os agentes leem antes de criar. Escreva-os ou deixe-os crescer.',
  memoryIntroDecisions:
    '— o feedback que você dá aos agentes é registrado aqui automaticamente assim que é atendido. Quando uma preferência se repete, o Doop sugere adicioná-la às suas regras.',
  memorySuggestion: 'Sugestão de memória',
  memoryFromDecisions: { one: 'a partir de {count} decisão', other: 'a partir de {count} decisões' },
  memoryDismiss: 'Dispensar',
  memoryAddToRules: 'Adicionar às regras',
  memoryNoReferences:
    'Nenhuma referência ainda. Fixe um frame de que você gosta (Fixar como referência, no inspetor dele) e os agentes copiarão as cores, a tipografia e o layout dele em novos designs.',
  memoryNew: '+ Nova',
  memoryRulesHint: 'Guias de estilo que todo agente lê antes de criar aqui.',
  memoryDistilled: 'consolidada',
  memoryReference: 'Referência',
  memoryReferenceGone: 'Esta referência não está mais fixada.',
  memoryPinnedBy:
    'fixada por {name} · {date} — os agentes copiam as cores, a tipografia e o layout deste design em novos trabalhos',
  memoryUnpin: 'Desafixar',
  memorySaveFailed: 'falha ao salvar',
  memoryNewRule: 'Nova regra',
  memoryEditRule: 'Editar regra',
  memoryRule: 'Regra',
  memoryNamePlaceholder: 'Nome, ex.: “Imagens em destaque”',
  memoryId: 'id:',
  memoryRulePlaceholder: '# Regras\n\nPaleta, fontes, receitas de layout, URLs de assets…',
  memorySaving: 'Salvando…',
  memoryGuideGone: 'Este guia de design não existe mais.',
  memoryEditedBy: 'editado por {name} · {date}',
  memoryDeleteTitle: 'Excluir “{title}”?',
  memoryDeleteDescription:
    'Os agentes deixam de criar com esta regra a partir da próxima tarefa. O histórico de versões é mantido, então você pode restaurá-la depois.',
  memoryDeleteConfirm: 'Excluir guia',
  memoryHistory: 'Histórico',
  memoryEdit: 'Editar',
  memoryHistoryFailed: 'não foi possível carregar o histórico',
  memoryHistoryTitle: '{title} — histórico',
  memorySavedBy: 'salvo por {name} · {date}',
  memoryDeletedBy: 'excluído por {name} · {date}',
  memoryDeletionVersion: 'Esta versão marca uma exclusão — não há nada para mostrar.',
  memoryRestoring: 'Restaurando…',
  memoryRestore: 'Restaurar esta versão',
  memoryNoVersions: 'Nenhuma versão registrada ainda.',
  memoryVersionDeleted: 'excluída',
  memoryVersionCurrent: 'atual',

  activityPanelAria: 'Painel de agentes',
  activityAgents: 'Agentes',
  activityComments: 'Comentários',
  activityCommentsOpen: { one: 'Comentários · {count} aberto', other: 'Comentários · {count} abertos' },
  activityCommentsTitle: 'Comentários — todas as conversas fixadas nesta página',
  activityActivity: 'Atividade',
  activityMemory: 'Memória',
  activityMemoryTitle: 'Memória de design — referências, regras e decisões com que cada agente deste canvas cria',
  activityClosePanel: 'Fechar painel',
  activityRecentTasks: 'Tarefas recentes',
  activityNoTasks:
    'Nenhuma tarefa ainda. Peça ao Doop Agent abaixo ou conecte o seu — o que os agentes fazem aparece aqui.',
  activityWorkingOn: 'Em andamento',
  activityWorkedOn: 'Concluídas',
  activityShowLess: 'Mostrar menos',
  activityShowAll: 'Mostrar tudo',
  activityTaskUnfinished: 'O agente não terminou esta tarefa.',
  activityGoTo: 'Ir para “{name}”',
  activityFor: 'para {name}',
  activityStopTitle: 'Parar esta tarefa',
  activityStop: 'Parar',
  activityRetry: 'Tentar de novo',
  activityEmpty: 'Nenhuma atividade ainda. Adicione um frame ou conecte um agente.',

  promptSendFailed: 'Algo deu errado — tente de novo',
  promptElement: 'elemento',
  promptTooBig: '“{name}” excede o limite de 5 MB',
  promptTooMany: { one: 'Até {count} imagem por pedido', other: 'Até {count} imagens por pedido' },
  promptRemoveAttachment: 'Remover {name}',
  promptScopedFrame: 'Restrito ao frame “{name}”',
  promptScopedElement: 'Restrito a {name} neste frame',
  promptRemoveFrameScope: 'Remover restrição ao frame',
  promptRemoveElementScope: 'Remover restrição ao elemento',
  promptAria: 'Pergunte ao Doop Agent',
  promptPlaceholderFrame: 'O que deve mudar neste frame…',
  promptPlaceholderElement: 'O que deve mudar neste elemento…',
  promptPlaceholder: 'Peça ao Doop para criar algo…',
  promptAttach: 'Anexar imagens',
  promptAttachTitle: 'Anexar capturas de tela ou imagens',
  promptSendTooltip: 'Enviar (Enter)',
  promptSend: 'Enviar',
  promptSent: 'O Doop Agent já está nisso — acompanhe o canvas',

  modelFallback: 'Modelo',
  modelAria: 'Modelo: {label}',
  modelCaption: 'Modelo do Doop Agent',
  modelNoAccount:
    'Nenhuma conta de modelo conectada — o Doop Agent usa o modelo do servidor quando houver um configurado.',
  modelSettings: 'Configurações do modelo…',
  modelConnect: 'Conectar um modelo…',

  shareAccessNone: 'Sem acesso',
  shareAccessView: 'Ver',
  shareAccessComment: 'Comentar',
  shareAccessEdit: 'Editar',
  shareSummaryNone: 'Canvas só para convidados',
  shareSummaryView: 'Qualquer pessoa com o link pode ver',
  shareSummaryComment: 'Qualquer pessoa com o link pode comentar',
  shareSummaryEdit: 'Qualquer pessoa com o link pode editar',
  shareCategoryWebsite: 'Sites',
  shareCategoryApp: 'Apps web',
  shareCategoryDashboard: 'Dashboards',
  shareCategoryMobile: 'Mobile',
  shareCategoryMarketing: 'Marketing',
  shareCategoryOther: 'Outros',
  shareMoveFailed: 'falha ao mover',
  shareInviteFailed: 'falha ao convidar',
  shareRemoveFailed: 'falha ao remover',
  shareAccessFailed: 'falha ao atualizar o acesso',
  sharePublishFailed: 'falha ao publicar',
  shareCopyFailed: 'Não foi possível copiar o link. Copie a URL do seu navegador.',
  shareTitle: 'Compartilhar “{name}”',
  shareInvitePlaceholder: 'Convidar por e-mail (conta doop)',
  shareInvite: 'Convidar',
  shareYou: '{name} (você)',
  shareOwner: 'Dono',
  shareLeave: 'Sair deste canvas',
  shareRemove: 'Remover {name}',
  shareCanEdit: 'Pode editar',
  shareEveryoneIn: 'Todos em {name}',
  shareEveryoneInWorkspace: 'Todos no workspace',
  sharePeople: { one: '{count} pessoa', other: '{count} pessoas' },
  shareWorkspaceMembers: 'membros do workspace',
  shareWorkspace: 'Workspace',
  shareWorkspaceAria: 'Workspace em que este canvas fica',
  sharePersonal: 'Pessoal — só para convidados',
  shareNeedsPlan: '(precisa de um plano)',
  shareAnyoneCan: 'Qualquer pessoa com o link pode…',
  shareLinkAria: 'O que qualquer pessoa com o link pode fazer',
  shareLinkTitle: 'Sem acesso = só você, pessoas convidadas e membros do workspace podem abrir este canvas',
  shareCopyLink: 'Copiar link',
  shareUpgradeReason: 'Mover um canvas para um workspace exige um plano Team.',
  shareGalleryTitle:
    'Qualquer pessoa no doop pode visualizar e copiar um canvas listado. O canvas em si continua privado.',
  shareGallery: 'Mostrar na galeria da comunidade',
  shareGalleryBlurb: 'As pessoas podem visualizá-lo e copiá-lo para a própria conta. Seu canvas continua privado.',
  shareDescriptionPlaceholder: 'O que é este design? Uma ou duas linhas ajudam as pessoas a encontrá-lo.',
  shareShelf: 'Prateleira da galeria',
  shareUpdateListing: 'Atualizar anúncio',

  exportNothing: 'Nada para exportar ainda',
  exportNothingLede: 'Adicione um frame a esta página primeiro.',
  exportPdfTitle: 'Exportar como PDF',
  exportPdfLede:
    'Os frames marcados viram um único PDF, uma página vetorial por frame no tamanho dele, na ordem abaixo: de cima para baixo e depois da esquerda para a direita no canvas.',
  exportSelectAll: 'Selecionar tudo',
  exportClear: 'Limpar',
  exportFramesAria: 'Frames para exportar',
  exportUntitled: 'Frame sem título',
  exportPdfMax: { one: 'Um PDF comporta no máximo {count} frame.', other: 'Um PDF comporta no máximo {count} frames.' },
  exportUncheck: { one: 'Desmarque {count} frame para baixar.', other: 'Desmarque {count} frames para baixar.' },
  exportPdfHint: 'O texto continua selecionável. Um documento longo pode levar alguns segundos por página.',
  exportDownloadPdf: 'Baixar PDF',
  exportDownloadPdfPages: { one: 'Baixar PDF ({count} página)', other: 'Baixar PDF ({count} páginas)' },
  exportFailed: 'Não foi possível exportar o {label}',
  exportTimedOut: 'A exportação do {label} demorou demais — tente de novo',
  exportSaveFailed: 'Não foi possível salvar “{name}”',
  exportReady: '“{name}” está pronto',
  exportingMore: { one: 'Exportando mais {count}…', other: 'Exportando mais {count}…' },
  exportingFormat: 'Exportando {label}…',
  exportingPdf: 'Exportando PDF…',
  exportingPdfFrames: { one: 'Exportando PDF de {count} frame…', other: 'Exportando PDF de {count} frames…' },
  copyPngUnsupported: 'Este navegador não consegue copiar imagens',
  copyingPng: 'Copiando PNG…',
  copyPngFailed: 'Não foi possível copiar o PNG',
  copyPngTimedOut: 'A cópia do PNG demorou demais — tente de novo',
  copyPngDone: 'PNG copiado',

  frameExportTitle: 'Exportar “{name}”',
  frameExportLede: 'Baixe este frame como imagem PNG ou JPG, ou como PDF vetorial.',
  frameExportPng: 'Baixar PNG',
  frameExportJpg: 'Baixar JPG',
  frameExportPdfGroup: { one: 'Baixar PDF de {count} frame', other: 'Baixar PDF de {count} frames' },
  frameExportPdfGroupHint: 'Uma página vetorial por frame, de cima para baixo e depois da esquerda para a direita',
  frameExportPdfHint: 'Página vetorial do tamanho do frame, com texto selecionável',

  historyTitle: '“{name}” — histórico de versões',
  historyLoadFailed: 'Não foi possível carregar o histórico de versões',
  historyVersionFailed: 'Não foi possível carregar esta versão',
  historyRestoreFailed: 'Não foi possível restaurar esta versão',
  historyRestored: '“{name}” restaurado para a versão de {when}',
  historyCurrentBy: 'design atual · última edição por',
  historyBy: 'por',
  historyLoadingVersion: 'Carregando esta versão…',
  historyLede:
    'Todo design substituído por um redesign, uma transmissão ou uma restauração fica guardado aqui. Escolha um para visualizar e depois restaure-o para todos no canvas.',
  historyCurrent: 'Atual',
  historyEmpty: 'Nenhuma versão anterior ainda — elas aparecem quando um design é substituído.',

  importTitle: 'Importar para o Doop',
  importLede:
    'Escolha uma origem. Importações que encontram várias páginas ou frames mostram uma revisão antes de qualquer coisa entrar.',
  importSoon: 'Em breve',
  importWebsite: 'Site',
  importWebsiteBlurb: 'Uma página, ou descubra um site inteiro.',
  importLiveApp: 'App ao vivo',
  importLiveAppBlurb: 'Atrás de um login, de uma VPN ou em localhost.',
  importGithub: 'Repositório do GitHub',
  importGithubBlurb: 'Telas lidas a partir das rotas do repositório.',

  protoScreenGone: 'Essa tela não está mais no canvas',
  protoOverlayGone: 'Essa sobreposição não está mais no canvas',
  protoAria: 'Protótipo: {name}',
  protoMissing: 'Tela ausente',
  protoMissingLower: 'tela ausente',
  protoRestart: 'Reiniciar protótipo',
  protoHotspots: 'Mostrar áreas clicáveis',
  protoNewTab: 'Abrir protótipo em uma nova aba',
  protoScaling: 'Escala',
  protoScalingRecommended: 'Recomendado',
  protoScalingOther: 'Outras opções de escala',
  protoScaleActual: 'Tamanho real (100%)',
  protoScaleResponsive: 'Responsivo',
  protoScaleFitWidth: 'Ajustar à largura',
  protoScaleFit: 'Ajustar à largura e altura',
  protoScaleFill: 'Preencher a tela',
  protoExit: 'Sair do protótipo',
  protoExitTitle: 'Sair (Esc)',
  protoDeleted: 'Esta tela foi excluída do canvas.',
  protoMissingFrame: 'frame ausente',
  protoStart: 'Início',
  protoCloseOverlay: 'Fechar sobreposição',
  protoScriptElement: 'Um script cria este elemento — conecte-o no HTML',
  protoLinked: 'O clique agora leva a “{name}”',
  protoHandle: 'Arraste até um frame para vinculá-lo',
  protoNotFound: 'Protótipo não encontrado',
  protoNotFoundText: 'Este canvas não existe ou o link está errado.',
  protoBackToCanvases: 'Voltar aos seus canvases',
  protoNothing: 'Nada para reproduzir ainda',
  protoNothingText: 'Esta página do canvas não tem frames.',
  protoOpenCanvas: 'Abrir o canvas',
}
